const state = {
  rev: {
    name: '',
    id: '',
    phase: 'relate',
    status: '',
    onHoldReason: null,
    onHoldBy: null,
    onHoldAt: null,
    canceledReason: null,
    canceledBy: null,
    canceledAt: null,
    points: 0,
    author: {},
    team: {
      owner: {},
      coach: {},
      collaborators: [],
    },
    attachments: [],
    likes: [],
    categories: [],
    location: {
      organization: {},
      site: {},
      tags: [],
    },
    financialMetadata: {
      revCurrency: '',
      exchangeRate: 0,
      organizationCurrency: '',
    },
    relate: {
      problem: '',
      idea: '',
      expectedResult: '',
      media: [],
      categories: [],
    },
    experiment: {
      whatDidYouDo: '',
      media: [],
    },
    verify: {
      didExperimentWork: true,
      learned: '',
    },
    expand: {
      media: [],
      solution: '',
      isImplemented: true,
      whyNotImplemented: '',
    },
    review: {
      costReduction: null,
      revenue: null,
      investment: null,
      costReductionExchange: null,
      revenueExchange: null,
      investmentExchange: null,
      estimationComment: '',
      timeInvested: null,
      timeReductionByMonth: null,
    },
    validation: {
      implementation: false,
      financial: false,
      highlight: false,
      implementationWasValidated: false,
      financialWasValidated: false,
      implementationValidatedBy: false,
      financialValidatedBy: false,
    },
    reviewPhase: {},
    validationRequest: {},
    notes: '',
    createdAt: '',
    updatedAt: '',
    type: 'improvementIdea',
  },
  availableCollaborators: [],
  availableCoaches: [],
  availableOwners: [],
  challenges: [],
  likedByMe: false,
  approvedByMe: '',
  approvals: [],
  isApproved: false,
  totalLikes: 0,
  dueDate: null,
  impactStartsAt: null,
  impactEndsAt: null,
  replicatedFromRevId: null,
  routineId: null,
  findingId: null,
}

export default state
